module.exports = __webpack_public_path__ + "img/canada-digestive-diseases-female.c7e1da32.png";